import React from 'react';
import ProductBoxNarrow from 'modules/shared/components/product/product-box-narrow';
import { ProductBoxNarrowProps } from 'modules/shared/components/product/product-box-narrow/product-box-narrow.props';

import './product-proposed.scss';

const ProductProposed: React.FC<{ proposedProducts: ProductBoxNarrowProps[]; }> = ({ proposedProducts }) => (
    <div className="product-proposed">
        <div className="product-proposed__container row">
            {proposedProducts.map((product) => (
                <div key={product.id} className="col col-2 col-md-3 col-sm-6 col-xs-6">
                    <ProductBoxNarrow
                        key={product.id}
                        product={product}
                    />
                </div>
            ))}
        </div>
    </div>
);

export default ProductProposed;
